import React from 'react';

import { useShowHide, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { modals } from '@modals';
import { ROUTES, useNavigation } from '@navigation';
import { useIsOperator, useNavigationStep } from '@store';

interface DoubtsAndExitOutput {
	resources: DoubtsAndExitResources;
	onHandleLink: () => void;
	onHandleLinkExit: () => void;
}

interface DoubtsAndExitResources {
	hasDoubtsAndTalkWithUs: string;
	exit: string;
	navigateMbcp: string;
}

export const useDoubtsAndExit = (): DoubtsAndExitOutput => {
	const t = useTranslation();
	const { exit } = useNavigation();
	const { current: currentRoute } = useNavigationStep();
	const { show: showExitModule } = useShowHide(modals.exitModule);
	const { show: showNeedHelp } = useShowHide(modals.needHelp);
	const isOperator = useIsOperator();

	const resources: DoubtsAndExitResources = {
		hasDoubtsAndTalkWithUs: t('general.hasDoubtsAndTalkWithUs'),
		exit: t('general.exit'),
		navigateMbcp: t('general.exit.navigateMbcp'),
	};

	const onHandleLink = () => showNeedHelp();

	const onHandleLinkExit = React.useCallback(() => {
		if (currentRoute === ROUTES.subscriptionConclusion || isOperator) {
			exit();
		} else {
			showExitModule();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resources.navigateMbcp]);

	return {
		resources,
		onHandleLink,
		onHandleLinkExit,
	};
};
